// eslint-disable-next-line no-restricted-imports
import {
  SourceCurrency as ISourceCurrency,
  TargetCurrency as ITargetCurrency,
  TBalance as ITBalance,
} from '@eih-netbroker/api-account';
// eslint-disable-next-line no-restricted-imports
import {} from '@eih-netbroker/api-account';

export type SourceCurrency = ISourceCurrency;

export type SourceCurrencyList = Array<SourceCurrency>;

export type TargetCurrency = Required<ITargetCurrency>;

export type TargetCurrencyList = Array<TargetCurrency>;

export type TBalance = ITBalance;

export enum ExchangeDirection {
  TargetToSource = 'TargetToSource',
  SourceToTarget = 'SourceToTarget',
}
